<template>
  <v-container
    fluid
    id="data-tables"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <base-v-component
          heading="Список ссылок на загрузку фото"
        />
        <base-material-card
          color="primary"
          icon="mdi-script"
          inline
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Ссылки
            </div>
          </template>

          <v-data-table
            :headers="headers"
            :items="items"
            :search.sync="search"
            multi-sort
            :footerProps="datatable_footer"
          >
          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
            {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
            </template>
            <template v-slot:top>
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="2"  xl="2">
                      <v-text-field
                        v-model="form.date.from"
                        label="Дата начала"
                        type="date"
                        @keyup.enter="load"
                      />
                    </v-col>
                    <v-col cols="12" md="2" xl="2">
                      <v-text-field
                        v-model="form.date.to"
                        label="Дата конца"
                        type="date"
                        @keyup.enter="load"
                      />
                    </v-col>                           
                    <v-col cols="12" md="2" xl="1">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        @click="load"
                      >
                        Поиск
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
            <template v-slot:item.created="{item}">
              {{format(item.created)}}
            </template>
            <template v-slot:item.changed="{item}">
              <span v-if="item.changed">
                {{format(item.changed)}}
              </span>
            </template>
            <template v-slot:item.valid="{item}">
              <span v-if="item.valid">
                {{format(item.valid)}}
              </span>
            </template>
            <template v-slot:item.accident="{item}">
              <span style="cursor:pointer" @click="$router.push('/accident/list?id=' + item.accident)">Перейти к ДТП</span>
            </template>
          </v-data-table>
        </base-material-card>
        
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      datatable_footer: {
        itemsPerPageText: 'Показывать по', pageText: 'из',
        itemsPerPageAllText: 'Все'
      },
      headers: [
        {
          text: 'Время создания',
          value: 'created',
        },
        {
          text: 'Время загрузки',
          value: 'changed',
        },
        {
          text: 'Срок действия',
          value: 'valid',
        },
        {
          text: 'ДТП',
          value: 'accident',
        },
      ],
      form: {
        date: {

        }
      },
      items: [],
      search: undefined,
    }),
    mounted: function () {
      this.form.date.from = moment().format('YYYY-MM-DD')
      this.form.date.to = moment().format('YYYY-MM-DD')
      this.load()
    },
    methods: {
      format: function(date) {
        return moment(date).format('DD.MM.YYYY HH:mm')
      },
      load: function (clear) {
        this.axios.post('/api/photo/list', this.form)
          .then(result => {
            if (!result.data.error) {
              this.items = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    }
  }
</script>
